import { defineCollection } from "@rebasepro/common";
/**
 * One row per sourcing-agent run — the observability trail for the nightly
 * cron (full logs also live in Studio's cron panel, but those are in-memory).
 */
const agentRunsCollection = defineCollection({
    name: "Agent runs",
    singularName: "Agent run",
    slug: "agent_runs",
    table: "agent_runs",
    properties: {
        id: {
            name: "ID",
            type: "string",
            isId: "uuid"
        },
        job: {
            name: "Job",
            type: "string",
            validation: { required: true },
            defaultValue: "source-leads"
        },
        success: {
            name: "Success",
            type: "boolean",
            defaultValue: true
        },
        scanned: {
            name: "Scanned",
            type: "number",
            description: "Raw candidates fetched from all sources"
        },
        prefiltered: {
            name: "Prefiltered",
            type: "number",
            description: "Candidates left after keyword/length/dedup prefilter"
        },
        duplicates: {
            name: "Duplicates",
            type: "number",
            description: "Candidates dropped because the URL was already a lead"
        },
        kept: {
            name: "Kept",
            type: "number",
            description: "Leads inserted (score ≥ 3)"
        },
        duration_ms: {
            name: "Duration (ms)",
            type: "number"
        },
        model_calls: {
            name: "Model calls",
            type: "number",
            description: "Calls this run made, including the ones the budget refused"
        },
        cost_usd: {
            name: "Est. cost (USD)",
            type: "number",
            description: "Estimated spend for this run — the per-call detail is in Model spend"
        },
        sources: {
            name: "Sources",
            type: "string",
            admin: { markdown: true },
            description: "Per-source yield for this run — the table to read when the board is empty"
        },
        notes: {
            name: "Notes",
            type: "string",
            admin: { markdown: true },
            description: "Source errors, model issues, anything unusual"
        },
        started_at: {
            name: "Started at",
            type: "date",
            autoValue: "on_create",
            admin: { readOnly: true }
        }
    },
    admin: {
        icon: "Activity",
        group: "Diagnostics",
        defaultViewMode: "table",
        display: {
            title: "job"
        },
        sort: ["started_at", "desc"],
        propertiesOrder: [
            "job",
            "success",
            "scanned",
            "prefiltered",
            "duplicates",
            "kept",
            "duration_ms",
            "model_calls",
            "cost_usd",
            "sources",
            "notes",
            "started_at"
        ]
    }
});
export default agentRunsCollection;
